import { render, staticRenderFns } from "./ModalAddConsultation.vue?vue&type=template&id=0c487290&scoped=true"
import script from "./ModalAddConsultation.vue?vue&type=script&lang=js"
export * from "./ModalAddConsultation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c487290",
  null
  
)

export default component.exports